import { PayloadAction } from '@reduxjs/toolkit';
import { GettyImagesImageSearchResponse } from 'store/studioSearch/types';
import { PublicAssetProductState } from '../types';

const setSimilarImagesReducer = (
  state: PublicAssetProductState,
  action: PayloadAction<GettyImagesImageSearchResponse>,
) => {
  state.similarImages = action.payload;
};

export default setSimilarImagesReducer;
